import { DESCRICAO, FINAL_JORNADA } from '../constants'

export function setFinalJornada(state) {
  state.fim = state.jornada.fim
  state.jornada.state = FINAL_JORNADA
  state.jornada.descricao = DESCRICAO[FINAL_JORNADA]
  state.jornada.inicio = state.inicio
}
